var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18770",
    transform: "translate(-480 -448)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1126",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(480 448)",
    style: {
      fill: "#84ffdb"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(497 464.43)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59579",
    d: "M13.515 18.286a6.858 6.858 0 1 0-6.858-6.858 6.858 6.858 0 0 0 6.858 6.858z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59580",
    d: "M22.486 23.951A12.521 12.521 0 0 0 1 32.686a1.2 1.2 0 0 0 1.2 1.2h22.632a1.2 1.2 0 0 0 1.2-1.2 12.08 12.08 0 0 0-.582-3.749 12.432 12.432 0 0 0-2.964-4.986z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1168",
    cx: 5.1,
    cy: 5.1,
    r: 5.1,
    transform: "translate(22.9 8.686)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59581",
    d: "M28 20.29a8.978 8.978 0 0 0-4.567 1.268c.26.233.523.462.769.714a14.866 14.866 0 0 1 3.542 5.959 13.786 13.786 0 0 1 .524 2.258h7.531a1.2 1.2 0 0 0 1.2-1.2 9.01 9.01 0 0 0-9-9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCredit);
export default __webpack_public_path__ + "static/media/customer_credit.6f58b68f96f0dadfdaa54234b67f9d13.svg";
export { ForwardRef as ReactComponent };